import React from 'react';
import moment from 'moment';
import FilterInputField from '../../components/TableFilter/ColumnsFilters/FilterInputField';
import { Color } from '../../components/ThemeProvider/ThemeStyle';

const styles = {
  textAlign: 'center',
  alignSelf: 'center'
};

const styles_head = {
  position: 'relative',
};
export const ReportDDOColumns = ({ t, days, open, cause, lang, isEditHead, isEdit,openStatusModal,
                                   isPrevMonthSelected
                                 }) => {
  let newDays = []
  days && days.forEach(item => {
    newDays.push({
      Header: <div
        onClick={() => {if (open && isEditHead) {
          open({
            isHead: true,
            logDate: item,
            isVisited: false,
            cause: "TECHNICAL_ERROR"
          })
        }}}
        className={isEditHead ? 'rt-th-my rt-th-my_hover' : 'rt-th-my'}
      >{String(moment(item).format('DD'))}</div>,
      style: styles_head,
      accessor: item,
      Cell: ({original}) => {
        let currentVisited = null;
        let text = null;
        if (original?.visitsInfo) {
          original.visitsInfo.forEach((visitInfo) => {
            if (visitInfo.logDate === item) {
              currentVisited = visitInfo;
              currentVisited['userID'] = original.childId ? original.childId : original.staffId;
            }
          })
        }
        cause.forEach((item) => {
          if (item.code === currentVisited?.['absenceReason']) {
            if (lang === 'ru') {
              text = item?.fisrt_letter_ru
            } else {
              text = item?.first_letter_kk
            }
          }
        })
        return (
          <>
            {
              currentVisited?.isVisited === false && <div
                style={{
                  backgroundColor:
                    currentVisited.absenceReason && Color.injury  ||
                    Color.secondary,
                  textAlign: 'center',
                  transform: 'scale(2)',
                  marginTop: 1,
                  display: 'list-item',
                  cursor: 'pointer'
                }}
                onClick={() => {if (open) {
                  open(currentVisited)
                }}}
              >
                {
                  text ? <span style={{ transform: 'scale(0.45)', display: 'block', color: '#000', minWidth: '2px' }}> {text} </span>
                    : <span style={{ transform: 'scale(0.45)', display: 'block', color: Color.secondary, minWidth: '2px',  }}> - </span>
                }
              </div>
            }
            {
              currentVisited?.isVisited === true &&
              <div
                style={{
                  backgroundColor: Color.bgColorSuccess,
                  textAlign: 'center',
                  transform: 'scale(2)',
                  marginTop: 1,
                  display: 'list-item',
                  cursor: 'pointer'
                }}
                onClick={() => {if (open) {
                  open(currentVisited)
                }}}
              >
                <span style={{ transform: 'scale(0.55)', display: 'block' }}> + </span>
              </div>
            }
          </>
        )
      },
      Filter: <span></span>,
    })
  });
  let daysTable = [
    {
      Header: '№',
      accessor: 'rowNumber',
      maxWidth: 100,
      width: 100,
      filterable: false,
      Cell: (row) => row.original.iin && row.index + 1,
    },
    {
      Header: 'ID',
      accessor: 'childId',
      Filter: <FilterInputField name="childId" type="number" />,
      maxWidth: 150,
      width: 150,
      Cell: ({ original}) => {
        return (
          <div>
            {original.childId && original.childId}
            {original.staffId && original.staffId}
          </div>
        )
      },
    },
    {
      Header: t('pageReport_fullName'),
      accessor: 'fullName',
      Filter: <FilterInputField name="fullName" />,
      Cell: ({ original}) => {
        return (
          <div style={{fontWeight: original.totalFinish ? 600 : null}}>
            {original.surname} {original.name} {original?.middlename}
          </div>
        )
      },
      maxWidth: 470,
      width: 470,
    },
    ...newDays,
    {
      Header: t('pageReport_visitedDays'),
      accessor: 'visitedDays',
      Filter: <span></span>,
      maxWidth: 250,
      width: 250,
      style: styles,
      Cell: ({ original}) => {
        return (
          <div style={{fontWeight: original.totalFinish ? 600 : null}}>
            {original.visitedDays}
          </div>
        )
      },
    },
    {
      Header: <div>
        <p className='reportBorderBottom'>{t('pageReport_missedDays')}</p>
        <div style={{ display: 'flex' }}>
          <p className="reportBorderRight reportCauseTable"
             style={{ width: '15%', maxWidth: '15%' }}>{t('pageReport_reference')}</p>
          <p className="reportBorderRight reportCauseTable"
             style={{ width: '30%', maxWidth: '30%' }}>{t('pageReport_applicationLeave')}</p>
          <p className="reportBorderRight reportCauseTable"
             style={{ width: '30%', maxWidth: '30%' }}>{t('pageReport_statementParents')}</p>
          <p className="reportCauseTable" style={{ width: '17%', maxWidth: '20%' }}>{t('pageReport_withReason')}</p>
          <p className="reportCauseTable" style={{ width: '23%', maxWidth: '26%' }}>{t('pageReport_technicalError')}</p>
        </div>
      </div>,
      accessor: 'unvisitedDaysWithoutReason',
      Filter: <span></span>,
      maxWidth: 2100,
      width: 2100,
      Cell: ({ original}) => {
        return (
          <div style={{ display: 'flex' }}>
            <p className='reportBorderRight reportCauseTable' style={{
              width: '15%',
              maxWidth: '15%',
              fontWeight: original.totalFinish ? 600 : null
            }}>{original.unvisitedDaysWithReasonReference}</p>
            <p className='reportBorderRight reportCauseTable' style={{
              width: '30%',
              maxWidth: '30%',
              fontWeight: original.totalFinish ? 600 : null
            }}>{original.unvisitedDaysWithReasonLeaveApplication}</p>
            <p className='reportBorderRight reportCauseTable' style={{
              width: '30%',
              maxWidth: '30%',
              fontWeight: original.totalFinish ? 600 : null
            }}>{original.unvisitedDaysWithReasonParentStatement}</p>
            <p className='reportBorderRight reportCauseTable' style={{
              width: '17%',
              maxWidth: '20%',
              fontWeight: original.totalFinish ? 600 : null
            }}>{original.unvisitedDaysWithoutReason}</p>
            <p className="reportCauseTable" style={{
              width: '23%',
              maxWidth: '26%',
              fontWeight: original.totalFinish ? 600 : null
            }}>{original.unvisitedDaysWithReasonTechnicalError}</p>
          </div>
        )
      },
      style: styles
    },
  ];
  if (isPrevMonthSelected) {
    daysTable.push({
      Header: t('pageReport_status'),
      accessor: 'attendanceSheetConsentStatus',
      Filter: <span></span>,
      maxWidth: 200,
      width: 200,
      sortable: false,
      Cell: ({ original }) => {
        const status = original.attendanceSheetConsentStatus;
        const statusMap = {
          SIGNED: t('pageReport_statusSIGNED'),
          DENIED: t('pageReport_statusDENIED'),
          UNCONFIRMED: t('pageReport_statusUNCONFIRMED')
        };

        const value = statusMap[status] || '-';

        return (
          <div
            style={{
              cursor: status ? 'pointer' : 'default',
              fontWeight: 500
            }}
            onClick={() => {
              if (!status) return;
              if (openStatusModal) {
                openStatusModal({
                  status,
                  attendanceSheetConsentDate: original.attendanceSheetConsentDate,
                  attendanceSheetConsentDenialReason: original.attendanceSheetConsentDenialReason
                });
              }
            }}
          >
            {value}
          </div>
        );
      },
      style: {
        textAlign: 'center'
      }
    });
  }
  return daysTable
};
